// extracted by mini-css-extract-plugin
export var service = "service-module--service--23iUM";
export var serviceContent = "service-module--serviceContent--jX2dW";
export var serviceImage = "service-module--serviceImage--e6jwy";
export var serviceTitle = "service-module--serviceTitle--1S40E";